import { render, staticRenderFns } from "./TagsDropdownMenu.vue?vue&type=template&id=7155eadd"
import script from "./TagsDropdownMenu.vue?vue&type=script&lang=js"
export * from "./TagsDropdownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7155eadd')) {
      api.createRecord('7155eadd', component.options)
    } else {
      api.reload('7155eadd', component.options)
    }
    module.hot.accept("./TagsDropdownMenu.vue?vue&type=template&id=7155eadd", function () {
      api.rerender('7155eadd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manageTag/TagsDropdownMenu.vue"
export default component.exports